import { Pressable, StyleSheet, Text, View } from 'react-native';
import { AgeRatingDefinitions, AgeRatingKey } from 'utils/ageRating';
import { calcSizeForDevice } from 'utils/index';
import { Platform } from 'utils/platform';

import { Icons } from 'components/Icons';
import Rating from 'components/Rating';
import { WebDiv } from 'components/WebDiv';

type ProfileRatingPreviewProps = {
  ageRating: AgeRatingKey;
  onPress: () => void;
};

export const ProfileRatingPreview = ({ ageRating, onPress }: ProfileRatingPreviewProps) => {
  const rating = AgeRatingDefinitions[ageRating];

  return (
    <View style={[styles.container, !Platform.isTV && styles.webContainer]}>
      <View
        style={[
          styles.selectedRating,
          Platform.isTV ? styles.tvSelectedRating : styles.webSelectedRating,
        ]}>
        <Rating ageRatingKey={ageRating} size="md" />
        <Text style={styles.ratingText}>{rating?.title}</Text>
      </View>
      <WebDiv className="rounded-8">
        <Pressable accessibilityRole="button" style={styles.editBtn} onPress={onPress}>
          <Icons.Pencil
            width={calcSizeForDevice(24).toString()}
            height={calcSizeForDevice(24).toString()}
          />
          <Text style={styles.editBtnText}>Editar</Text>
        </Pressable>
      </WebDiv>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    height: calcSizeForDevice(44),
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  webContainer: {
    width: '100%',
    gap: 12,
  },
  selectedRating: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'rgba(209, 215, 255, 0.1)',
    borderRadius: 8,
    paddingVertical: calcSizeForDevice(6),
    paddingHorizontal: calcSizeForDevice(16),
  },
  tvSelectedRating: {
    width: calcSizeForDevice(359),
  },
  webSelectedRating: {
    flex: 1,
  },
  ratingText: {
    fontSize: calcSizeForDevice(16),
    fontWeight: '500',
    color: '#FFF',
    marginLeft: calcSizeForDevice(16),
  },
  editBtn: {
    width: calcSizeForDevice(155),
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 7, 56, 0.3)',
    borderWidth: 3,
    borderColor: '#2240FF',
    borderRadius: 32,
    padding: calcSizeForDevice(12),
  },
  editBtnText: {
    fontSize: calcSizeForDevice(16),
    fontWeight: '500',
    color: '#FFF',
    marginLeft: calcSizeForDevice(10),
  },
});
